import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { canUseOfflineWorkspace, clearWorkspaceDisplay, readWorkspaceDisplay, saveWorkspaceDisplay } from "@/lib/workspaceDisplayCache";

export const useOperationalAccess = (user, pathname) => {
  const [state, setState] = useState({ actorId: null, access: null, error: "", offline: false });
  useEffect(() => {
    let live = true;
    const load = async () => {
      try {
        const { data } = await api.get("/operational-catalogue/access");
        if (!live) return;
        saveWorkspaceDisplay(user.id, "access", data).catch(() => {});
        setState({ actorId: user.id, access: data, error: "", offline: false });
      } catch (error) {
        if (!live) return;
        if ([401, 403].includes(error.response?.status)) await clearWorkspaceDisplay(user.id).catch(() => {});
        const cached = !error.response && canUseOfflineWorkspace(user, pathname)
          ? await readWorkspaceDisplay(user.id, "access").catch(() => null) : null;
        if (live) setState({ actorId: user.id, access: cached, offline: !!cached,
          error: cached ? "" : formatApiError(error.response?.data?.detail) || error.message });
      }
    };
    if (user?.id) load();
    window.addEventListener("online", load);
    return () => { live = false; window.removeEventListener("online", load); };
  }, [user?.id, user?.role, pathname]);
  return state.actorId === user?.id ? state : { access: null, error: "", offline: false };
};